<template>
  <div>
    <Header Act="1"></Header>
    <div class="zhibo-list-page">
      <div class="back-home">
      <router-link to="/" class="back-home-link">返回首页</router-link>
    </div>
      <h2 class="zhibo-title">全部直播</h2>
    <div class="zhibo-list">
      <div
        v-for="item in pagedList"
        :key="item.id"
        class="zhibo-item"
        @click="openZhibo(item.address)"
      >
        <img :src="item.avatar" :alt="item.name" class="zhibo-img" />
        <div class="zhibo-info">
          <div class="zhibo-name">{{ item.name }}</div>
          <div class="zhibo-time">{{ item.beginTime }} ~ {{ item.endTime }}</div>
        </div>
      </div>
    </div>
    <div class="pagination" v-if="totalPages > 1">
      <button class="page-btn" :disabled="currentPage === 1" @click="goPage(currentPage-1)">&lt;</button>
      <button
        v-for="page in totalPages"
        :key="page"
        class="page-btn"
        :class="{active: page === currentPage}"
        @click="goPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-btn" :disabled="currentPage === totalPages" @click="goPage(currentPage+1)">&gt;</button>
    </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import Header from '../header/head.vue';
import Footer from '../header/footer.vue';
export default {
  name: 'ZhiboList',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      zhiboList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  computed: {
    pagedList() {
      return this.zhiboList;
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  created() {
    this.fetchPage(1);
  },
  methods: {
    openZhibo(address) {
      window.open(address, '_blank');
    },
    goPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.fetchPage(page);
      window.scrollTo(0, 0);
    },
    fetchPage(pageNum) {
      this.$get(`/api/v1/works/zhibo/list?pageNum=${pageNum}&pageSize=${this.pageSize}`).then(res => {
        if (res.data && (res.data.code === 0 || res.data.code === 200) && Array.isArray(res.data.rows)) {
          this.zhiboList = res.data.rows;
          this.total = res.data.total;
          this.currentPage = pageNum;
        }
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.zhibo-list-page {
  max-width: 1100px;
  margin: 40px auto;
  padding: 0 20px;
}
.back-home {
  margin-bottom: 18px;
}
.back-home-link {
  color: #333;
  font-size: 15px;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 4px;
  transition: background 0.2s;
}
.back-home-link:hover {
  background: #eee;
}
.zhibo-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
  text-align: center;
}
.zhibo-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}
@media screen and (max-width: 900px) {
  .zhibo-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
.zhibo-item {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.zhibo-item:hover {
  box-shadow: 0 6px 24px rgba(0,0,0,0.12);
  transform: translateY(-4px) scale(1.03);
}
.zhibo-img {
  width: 100%;
  max-width: 100%;
  height: 220px;
  object-fit: contain;
  background: #f8f8f8;
  border-radius: 12px 12px 0 0;
  display: block;
}
.zhibo-info {
  padding: 16px 12px 18px 12px;
  width: 100%;
  text-align: center;
}
.zhibo-name {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-bottom: 8px;
  word-break: break-all;
}
.zhibo-time {
  font-size: 13px;
  color: #888;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 0 0;
  gap: 8px;
}
.page-btn {
  min-width: 32px;
  height: 32px;
  border: none;
  background: #f2f2f2;
  color: #333;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}
.page-btn.active, .page-btn:hover {
  background: linear-gradient(90deg, #2bcc9f 0%, #649ab9 100%);
  color: #fff;
}
.page-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
</style> 